export const KnowledgeCenter = {
  List: {
    Data: null
  },

  Article: {
    Data: {}
  }
}
